import { convertWorkStatus } from "./dataProvider";
import {
  BranchModel,
  ReportModel,
  ShiftPlanEmployee,
  TempBranchPendingRequestModel,
  UserModel,
} from "./dataStructures";

function searchCompare(entity: string, searchString: string) {
  if (entity !== undefined && searchString !== undefined) {
    return entity.toLocaleLowerCase().match(searchString.toLocaleLowerCase());
  }
  return false;
}

export function filterUserSearchData(
  array_users: UserModel[],
  searchString: string
) {
  if (searchString.search(/[\]?*+|{}\\()@.\n\r]/) !== -1) {
    return array_users;
  }
  if (searchString === "") {
    return array_users;
  }

  searchString.replaceAll("+", "");
  const temp_users: UserModel[] = array_users.filter(
    (x) =>
      x.first_name !== null &&
      x.last_name !== null &&
      x.email_id !== null &&
      x.mobile !== null
  );

  // const array_filteredResults: UserModel[] = temp_users.filter(
  //   (x) =>
  //     x.first_name.toLowerCase().match(searchString.toLowerCase()) ||
  //     x.last_name.toLowerCase().match(searchString.toLowerCase()) ||
  //     x.email_id.toLowerCase().match(searchString.toLowerCase()) ||
  //     x.role.display_name.toLowerCase().match(searchString.toLowerCase()) ||
  //     x.mobile.toLowerCase().match(searchString.toLowerCase()) ||
  //     x.working_status.display_name
  //       .toLowerCase()
  //       .match(searchString.toLowerCase())
  // );

  const array_filteredResults: UserModel[] = temp_users.filter(
    (x) =>
      searchCompare(x.first_name, searchString) ||
      searchCompare(x.last_name, searchString) ||
      searchCompare(x.email_id, searchString) ||
      searchCompare(x.role.display_name, searchString) ||
      searchCompare(x.mobile, searchString) ||
      searchCompare(x.mobilePrefix, searchString) ||
      searchCompare(x.permanant_branch.name, searchString) ||
      searchCompare(x.working_status.display_name, searchString)
  );

  return array_filteredResults;
}

export function filterBranchSearchData(
  array_branches: BranchModel[],
  searchString: string
) {
  if (searchString.search(/[\]?*+|{}\\()@.\n\r]/) !== -1) {
    return array_branches;
  }
  if (searchString === "") {
    return array_branches;
  }

  const array_filteredBranches: BranchModel[] = array_branches.filter(
    (x) =>
      searchCompare(x.name, searchString) ||
      searchCompare(x.phone, searchString) ||
      searchCompare(x.address, searchString)
  );

  return array_filteredBranches;
}

export function filterReportSearchData(
  array_reports: ReportModel[],
  searchString: string
) {
  if (searchString.search(/[\]?*+|{}\\()@.\n\r]/) !== -1) {
    return array_reports;
  }
  if (searchString === "") {
    return array_reports;
  }
  const array_filteredReports: ReportModel[] = array_reports.filter(
    (x) =>
      searchCompare(x.title, searchString) ||
      searchCompare(x.department, searchString) ||
      searchCompare(x.signatory, searchString) ||
      match2(x.shift_plan?.log?.end_at, searchString) ||
      match2(x.approved_by_info?.first_name, searchString) ||
      match2(x.approved_by_info?.last_name, searchString) ||
      match2(x.team_lead_info?.first_name, searchString) ||
      match2(x.team_lead_info?.last_name, searchString) ||
      match2(x.shift_plan?.shift.title, searchString)
  );

  return array_filteredReports;
}

function match2(x: string | undefined, y: string | undefined) {
  if (x !== undefined && x !== null && y !== undefined && y !== null) {
    return x.toLowerCase().match(y.toLowerCase());
  }
  return false;
}

export function filterPendingRequestData(
  array_requests: TempBranchPendingRequestModel[],
  searchString: string
) {
  if (searchString.search(/[\]?*+|{}\\()@.\n\r]/) !== -1) {
    return array_requests;
  }
  if (searchString === "") {
    return array_requests;
  }
  const array_filteredRequests: TempBranchPendingRequestModel[] =
    array_requests.filter(
      (x) =>
        searchCompare(x.user.first_name, searchString) ||
        searchCompare(x.user.last_name, searchString) ||
        searchCompare(x.user.email_id, searchString) ||
        searchCompare(x.user.permanant_branch.name, searchString) ||
        searchCompare(x.request_status.display_name, searchString)
    );
  return array_filteredRequests;
}

export function filterAttendanceEmployeeData(
  array_employees: ShiftPlanEmployee[],
  searchString: string
) {
  if (searchString.search(/[\]?*+|{}\\()@.\n\r]/) !== -1) {
    return array_employees;
  }
  if (searchString === "") {
    return array_employees;
  }
  const array_filteredEmployees: ShiftPlanEmployee[] = array_employees.filter(
    (x) =>
      searchCompare(x.user.first_name, searchString) ||
      searchCompare(x.user.last_name, searchString) ||
      searchCompare(x.user.email_id, searchString) ||
      searchCompare(
        convertWorkStatus(x.current_state).display_name,
        searchString
      )
  );
  return array_filteredEmployees;
}

export function isValiEmail(val: string) {
  let regEmail =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!regEmail.test(val)) {
    return false;
  }
  return true;
}

export function checkEntity(value: string) {
  if (value === undefined) {
    return false;
  } else if (value === "") {
    return false;
  }
  return true;
}

export function makeRandomID(length: number) {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

/* **************************** Date Time Related //////////////////////// */
export function convertServerToTimePickerString(time_string: string) {
  if (time_string === undefined || time_string === null) {
    return time_string;
  }
  //const z = time_string.split("+")[1];
  //console.log("time string in convertServerToTimePickerString", time_string);
  const chunks = time_string.split(":");
  if (chunks !== undefined) {
    if (chunks.length > 1) {
      const hr = chunks[0];
      const mins = chunks[1];
      if (chunks.length <= 2) {
        const picker_string: string = ":00:" + chunks[1];
        return picker_string;
      } else {
        const secs = chunks[2].split(" ")[0];
        const picker_string: string = hr + ":" + mins + ":" + secs;
        return picker_string;
      }
    }
  }
  return time_string;
}

export function convertTimePickerToServerTime(picker_string: string) {
  if (picker_string === undefined) {
    return picker_string;
  }
  const timezoneOffset = new Date().getTimezoneOffset();
  const server_string: string = picker_string + ":00" + timezoneOffset;
  return server_string;
}

export function fomratDateToServerDate(given_date: Date) {
  if (given_date.getFullYear === undefined) {
    return given_date + "";
  }
  const format_date: string =
    given_date.getFullYear() +
    "-" +
    (given_date.getMonth() + 1) +
    "-" +
    given_date?.getDate();

  return format_date;
}

export function formateDateTimeToServerDateString(given_date: Date) {
  //this function is for start end time in attendance list of team lead
  //2024-09-18T06:19:51+02:00
  // const formatted_date: string =
  //   given_date.toLocaleDateString()+"T"+ given_date.toT();
  const formatted_date: string = given_date.toUTCString();
  return formatted_date;
}

export function convertServerToRegularDate(time_string: string) {
  if (time_string === undefined) {
    return time_string;
  }
  const chunks: string = time_string.split("T")[0];
  return chunks;
}

export function dateToString(date: Date) {
  if (date === null || date === undefined) {
    return "N/A";
  }
  if (typeof date === "string") {
    return date;
  }
  const startDateString: string =
    date.getDate() +
    "." +
    (date !== null ? date.getMonth() + 1 : 1) +
    "." +
    date?.getFullYear();
  return startDateString;
}

export function dateToStringForPicker(date: Date) {
  if (date === null || date === undefined) {
    return "N/A";
  }
  const startDateString: string =
    date?.getFullYear() +
    "-" +
    (date !== null ? date.getMonth() + 1 : 1) +
    "-" +
    date.getUTCDate();
  return startDateString;
}

export function serverDateStringToRegularDateString(dateString: string) {
  if (dateString === null || dateString === undefined) {
    return dateString;
  }
  const chunks = dateString.split("-");
  if (chunks !== undefined) {
    if (chunks.length > 1) {
      const year: string = chunks[0];
      const month: string = chunks[1];
      const day: string = chunks[2];
      const picker_string: string = day + "." + month + "." + year;
      return picker_string;
    }
  }
}

export function formatDateToDDMMYYYY(dateStr: string) {
  const date: Date = new Date(dateStr);

  if (isNaN(date.getTime())) {
    // Handle invalid date format
    return "Invalid Date";
  }

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
  const year = date.getFullYear();

  return `${day}.${month}.${year}`;
}
